// The locale dictionaries, aggregated for the CI key-parity gate
// (tools/ci/i18n-parity.ts, D-014) and for unit tests. The RUNTIME does not
// import this module: src/i18n.ts bundles `en`, and loads every other locale
// from its own module under src/locales/ when that locale is chosen, so a
// locale nobody uses costs nobody a download (D-430).
//
// Which locales exist is the registry's decision
// (packages/contracts/src/locales.ts), not this file's. Which are translated,
// and how far, is i18n-completeness.ts's, which the gate enforces. Each
// locale's `Dict` is checked against `en`'s key structure at compile time.

import { SUPPORTED_LOCALES, type Locale } from "@assessly/contracts/locales";
import { en, type Dict } from "./locales/en.js";
import { fr } from "./locales/fr.js";
import { hi } from "./locales/hi.js";
import { ru } from "./locales/ru.js";
import { zh } from "./locales/zh.js";
import { zhHant } from "./locales/zh-hant.js";

export { en, fr, hi, ru, zh, zhHant, type Dict, type Locale };

/** The locales gated by the CI key-parity check: the registry's six. */
export const LOCALES = SUPPORTED_LOCALES;

export const dictionaries: Record<Locale, Dict> = {
  en,
  ru,
  fr,
  zh,
  "zh-Hant": zhHant,
  hi,
};
